import React, { Suspense } from 'react';
import { Route } from 'react-router-dom';
import { Provider as GQLProvider } from 'urql';
import gqlClient from '../utils/gqlClient';
import Loader from './common/Loader';
import AppNav from './AppNav';
import { CurrentContextProvider } from '../contexts/CurrentContext';
import { SelectedProductContextProvider } from '../contexts/SelectedProductContext';
import { SelectedPlanContextProvider } from '../contexts/SelectedPlanContext';
import { CalculatePriceContextProvider } from '../contexts/CalculatePriceContext';
import Authoriser from './auth/Authoriser';
import { auth } from '../utils/Auth';

const Callback = React.lazy(() => import('./auth/Callback'));
const Dashboard = React.lazy(() => import('./dashboard/DashboardView'));
const Products = React.lazy(() => import('./products/ProductsView'));
const Payment = React.lazy(() => import('./payment/PaymentView'));
const PaymentSuccess = React.lazy(() => import('./payment/PaymentSuccessView'));
const Billing = React.lazy(() => import('./billing/BillingView'));
const BridgeSignup = React.lazy(() => import('./bridge/BridgeSignupView'));
const BridgeSignupSuccess = React.lazy(() => import('./bridge/BridgeSignupSuccess'));

const App: React.FunctionComponent = () => {
  return (
    <>
      <Suspense fallback={<Loader />}>
        <Route path="/callback" component={Callback} />
      </Suspense>
      <Authoriser>
        {auth.getIdToken() && (
          <GQLProvider value={gqlClient}>
            <CurrentContextProvider>
              <SelectedProductContextProvider>
                <SelectedPlanContextProvider>
                  <CalculatePriceContextProvider>
                    <AppNav />
                    <Suspense fallback={<Loader />}>
                      <Route exact path="/" component={Dashboard} />
                      <Route path="/plans" component={Products} />
                      <Route path="/payment" component={Payment} />
                      <Route path="/payment-success" component={PaymentSuccess} />
                      <Route path="/billing" component={Billing} />
                      <Route path="/bridge-signup" component={BridgeSignup} />
                      <Route path="/bridge-success" component={BridgeSignupSuccess} />
                    </Suspense>
                  </CalculatePriceContextProvider>
                </SelectedPlanContextProvider>
              </SelectedProductContextProvider>
            </CurrentContextProvider>
          </GQLProvider>
        )}
      </Authoriser>
    </>
  );
};

export default App;
